<div id="loading" [style.display]="isLoading ? 'inherit':'none' ">
  <!-- <sk-cube-grid class="icon" [isRunning]="true"></sk-cube-grid> -->
  <ui-loading-spinner></ui-loading-spinner>
</div>
